import React, { useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { connect, useDispatch } from "react-redux";
import { ApplicationState } from "../../../../../store";
import { bindActionCreators, Dispatch } from "redux";
import { getEvidenceInDataPeriod } from "../../../../../store/onboarding/actions";
import { DataPeriod } from "../../../../../store/onboarding/types";
import { changeRowSizeInPagination, currentLoadedRowInPagination, resetSortAction } from "../../../../../store/dataFilter/actions";

type PropsFromState = {
  errors: {
    getEvidenceData?: string;
  };
  isLoading: {
    getEvidenceData: boolean;
  };
  rowSizeInPaginationFilter: number;
  evidenceCurrentLoadedRowCount: number;
  evidenceTotalRowCount: number;
  currentDataPeriod?: DataPeriod;
};

type DispatchProps = {
    getEvidenceInDataPeriod: (dataPeriodId?: number) => any;
    changeRowSizeInPagination: (rowSize: number) => any;
    resetSortAction: () => any;
};

type Props = PropsFromState & DispatchProps;

const DataTablePagination = ({
    currentDataPeriod,
    isLoading,
    rowSizeInPaginationFilter,
    evidenceCurrentLoadedRowCount,
    evidenceTotalRowCount,
    getEvidenceInDataPeriod,
    changeRowSizeInPagination
}: Props) => {
    const dispatch = useDispatch();
    const [rowSize, setRowSize] = useState(rowSizeInPaginationFilter);
    const handleRowSizeInPaginationChange = (event: React.FormEvent<any>) => {
        event.preventDefault();
        let { value } = event.target as HTMLInputElement;
        let trancateValue = +value.replace(/\D/,'');
        let remainRowCount = evidenceTotalRowCount - evidenceCurrentLoadedRowCount;
        if(trancateValue > remainRowCount) {
          trancateValue = remainRowCount;
        }
        changeRowSizeInPagination(trancateValue);
        setRowSize(trancateValue);
    };
    
    const handleEvidenceInDataPeriod = () => {
      getEvidenceInDataPeriod(currentDataPeriod?.id);
      dispatch(resetSortAction());
    }
    return (
        <div className="container py-2">
            <div className="d-flex justify-content-center align-items-center pagination-class p-2">
                <span>Showing 
                  <b> {isLoading?.getEvidenceData ? <Spinner animation="border" size="sm" /> : evidenceCurrentLoadedRowCount} </b>
                  out of <b> {isLoading?.getEvidenceData ? <Spinner animation="border" size="sm" /> : evidenceTotalRowCount} </b> student rows</span>
                {evidenceCurrentLoadedRowCount < evidenceTotalRowCount
                ?
                <>
                  <div className="mx-3" style={{ width: '2px', height: '24px', backgroundColor: 'black' }}></div>
                  <div className="d-flex align-items-center">
                      <button 
                          className="blueBtnSm mr-2" 
                          disabled={
                              isLoading?.getEvidenceData 
                              || !rowSize 
                              || (evidenceCurrentLoadedRowCount == evidenceTotalRowCount)
                            }
                          onClick={handleEvidenceInDataPeriod}
                      > Load {isLoading?.getEvidenceData && <Spinner animation="border" size="sm" />}
                      </button>
                      <Form.Control
                          type="text" 
                          value={rowSizeInPaginationFilter}
                          onChange={handleRowSizeInPaginationChange}
                          className="form-control form-control-sm"
                          style={{width: '50px'}}
                          disabled={isLoading?.getEvidenceData}
                      />
                  </div>
                  <span className="ml-2">more out of 
                    <b> {isLoading?.getEvidenceData 
                          ? <Spinner animation="border" size="sm" /> 
                          : evidenceTotalRowCount - evidenceCurrentLoadedRowCount
                        } 
                    </b> remaining student rows</span>
                </>
              : ''}
              </div>
        </div>
    );
};

const mapStateToProps = ({ onboarding, dataFilter }: ApplicationState): PropsFromState => {
  return {
    errors: {
      getEvidenceData: onboarding.errors.getEvidenceInDatePeriod,
    },
    isLoading: {
      getEvidenceData: onboarding.isLoading.getEvidenceInDatePeriod,
    },
    rowSizeInPaginationFilter: dataFilter.rowSizeInPaginationFilter,
    evidenceCurrentLoadedRowCount: onboarding.evidencePeriodData?.student_rows.length || 0,
    evidenceTotalRowCount: onboarding.evidencePeriodData?.pagination?.total_row_count || 0
  };
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps =>
  bindActionCreators(
    {
      getEvidenceInDataPeriod: getEvidenceInDataPeriod,
      changeRowSizeInPagination: changeRowSizeInPagination,
      currentLoadedRowInPagination: currentLoadedRowInPagination,
      resetSortAction: resetSortAction
    },
    dispatch
  );
export default  connect(mapStateToProps, mapDispatchToProps)(DataTablePagination);